import { IProductGridConfig } from 'src/exported/product-grid-wrapper/ProductGridWrapper';
import { IQueryTypeFragments } from '~api/QueryFragments';
import { IProductFullConfig } from '~interfaces/IProductFull';
import { IItem } from './IItem';

export enum SortDirection {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}

export interface IProductDataOptionsSkuFilter {
    inventoryStatus?: string[];
    skuIds?: string[];
    isDefaultSku?: boolean;
    shades?: string[];
    includeInnerHits?: boolean;
}

export interface IProductDataOptionsTagFilter {
    ids?: string[];
    keys?: string[];
    values?: string[];
    includeInnerHits?: boolean;
}

export interface IProductDataOptionsFilters {
    tags?: IProductDataOptionsTagFilter;
    skus?: IProductDataOptionsSkuFilter;
    productIds?: string[];
}

export interface IProductDataOptionsTagSorter {
    productDisplayOrder: SortDirection;
}

export interface IProductDataOptionsSkusSorter {
    skuIds?: SortDirection;
    shades?: {
        name: SortDirection;
    };
}

export interface IProductDataOptionsSorters {
    tags?: IProductDataOptionsTagSorter;
    skus?: IProductDataOptionsSkusSorter;
    productIds?: SortDirection;
}

export interface IProductDataOptions {
    filterBy: IProductDataOptionsFilters;
    sortBy?: IProductDataOptionsSorters;
    query?: string;
    updateInventories?: boolean;
    productGridConfig?: IProductGridConfig;
    productFullConfig?: IProductFullConfig;
    gridItems?: IItem[];
}

export interface IProductDataParams {
    options: IProductDataOptions;
    queryFragments?: IQueryTypeFragments;
}
